<script setup lang="ts">
/**
 * @file This component handles the membership tier grids.
 */

withDefaults(
  defineProps<{
    /**
     * Defines whether the grid should be expanded or not.
     */
    isExpanded?: boolean
    /**
     * Grid variant.
     */
    variant?: OzMembershipTierGridVariant
  }>(),
  {
    isExpanded: true,
    variant: OzMembershipTierGridVariant.Default,
  },
)
</script>

<script lang="ts">
export enum OzMembershipTierGridVariant {
  // Expanded: 4x1 | Not expanded: 2x2
  Default = 'Default',
  // Expanded: 3x1 | Not expanded: 2x2
  SchoolLibrary = 'SchoolLibrary',
  // Expanded: 4x1 | Not expanded: 2x2
  SingleStep = 'SingleStep',
}

export default {}
</script>

<template>
  <div
    :class="[
      'grid',
      'items-center',
      variant === OzMembershipTierGridVariant.Default && isExpanded && ['grid-cols-membership-tier-grid', 'gap-y-0'],
      variant === OzMembershipTierGridVariant.SchoolLibrary && isExpanded && ['grid-cols-school-membership-tier-grid'],
      variant === OzMembershipTierGridVariant.SingleStep &&
        isExpanded && ['grid-cols-single-step-membership-tier-grid', 'gap-y-0', 'gap-x-1'],
      !isExpanded && ['grid-cols-2', 'gap-y-3', 'auto-rows-min'],
    ]"
  >
    <div class="order-1">
      <slot name="first" />
    </div>
    <div :class="['justify-self-start', isExpanded && ['order-2'], !isExpanded && ['order-3', 'self-start']]">
      <slot name="second" />
    </div>
    <div
      v-if="variant !== OzMembershipTierGridVariant.SchoolLibrary"
      :class="[
        isExpanded && ['order-3', 'justify-self-start'],
        !isExpanded && ['order-4', 'self-start', 'justify-self-end'],
      ]"
    >
      <slot name="third" />
    </div>
    <div :class="[isExpanded && ['order-4'], !isExpanded && ['order-2'], 'justify-self-end']">
      <slot name="fourth" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.grid-cols-membership-tier-grid {
  grid-template-columns: repeat(3, 1fr) 140px;
}

.grid-cols-school-membership-tier-grid {
  grid-template-columns: repeat(2, 1fr) 140px;
}

.grid-cols-single-step-membership-tier-grid {
  grid-template-columns: repeat(3, 1fr) 164px;
}
</style>
